module.exports = __webpack_public_path__ + "img/Investors.8b0907b6.svg";